module.exports = __webpack_public_path__ + "img/item_link_ringsize@2x.9663187.jpg";